import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import SectionHeading from '@/components/base/SectionHeading';
import { topics } from '@/mocks/topics';

export default function ProgressTimeline() {
  const events = topics
    .flatMap((topic) =>
      topic.updates.map((update) => ({
        ...update,
        slug: topic.slug,
        topicTitle: topic.title,
        categoryName: topic.categoryName,
      })),
    )
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 7);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <Container>
        <SectionHeading
          eyebrow="Live Timeline"
          title="全网进展时间线"
          desc="把不同专题的最新节点汇聚在一起，按日期倒序呈现，一眼看清最近都发生了什么。"
          linkText="进入追踪列表"
          linkPath="/tracking"
        />

        <ol className="mt-10 border-l-2 border-background-200 pl-0">
          {events.map((event, index) => (
            <li key={`${event.slug}-${event.date}-${index}`} className="relative pl-8">
              <span
                className={`absolute -left-[7px] top-6 flex h-3 w-3 items-center justify-center rounded-full border-2 border-background-50 ${
                  index === 0 ? 'bg-primary-600' : 'bg-accent-500'
                }`}
              ></span>
              <div className="border-b border-background-200 py-5">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span className="font-heading text-sm font-bold text-foreground-950">{event.date}</span>
                  <span className="rounded-full bg-background-200 px-2.5 py-0.5 text-[11px] text-foreground-700">
                    {event.categoryName}
                  </span>
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-900">
                    {event.tag}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  <Link to={`/topic/${event.slug}`} className="cursor-pointer transition-colors hover:text-primary-700">
                    {event.title}
                  </Link>
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{event.content}</p>
                <Link
                  to={`/topic/${event.slug}`}
                  className="mt-2 inline-flex cursor-pointer items-center gap-1 text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  追踪这条线索
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}